module.exports = __webpack_public_path__ + "static/media/view-external-link.af7e07a1.svg";